<template v-slot:append>
  <v-dialog v-bind="computedProps" v-on="computedListeners" v-model="showDialog">
    <v-card>
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer/>
        <v-toolbar-title>配車車両追加画面 ＜配車表 : {{haishahyoCdNm}}＞</v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <v-row no-gutters>
            <v-col :cols="3" class="px-1">
              <span class="search-number">{{ filteredRows.length }}</span>件 の車両が紐づけ可能です。
            </v-col>
            <v-col :cols="3" />
            <v-col :cols="3" class="mt-2">
              <span class="text-right-black-bold">さらにフリーワードで絞り込む</span>
            </v-col>
            <v-col :cols="3" class="px-1">
              <dd-narrow-down-text-box label="" adjustStyle="padding-top:0px" v-model="searchText"/>
            </v-col>
          </v-row>

          <hr class="section-line mb-2">

          <v-row no-gutters>
            <v-col :cols="6">
              <dd-custom-button
                v-if="modeKengen === 2"
                :disabled="isHimodukeButtonDisabled"
                @click="onHaishahyoSharyoRelationAddClick">
                チェックした車両を紐付ける
              </dd-custom-button>
            </v-col>
            <v-col :cols="6" class="px-1">
              <dd-select-items-per-page
                ref="pagination1"
                :itemsPerPage.sync="itemsPerPage"
                :currentPage.sync="page"
                :items="filteredRows"
                @changeItemsPerPage="changeItemsPerPage"
                @changePage="changePage"
              />
            </v-col>
          </v-row>

          <v-row no-gutters align-content="center">
            <v-col :cols="12">
              <v-data-table
                item-key="sharyoNo"
                :headers="headers"
                :items="filteredRows"
                :search="searchText"
                :loading="loading"
                @dblclick:row="onRowDoubleClick"
                v-model="selectedItem"
                showSelect
                :items-per-page="itemsPerPage"
                :page.sync="page"
                :custom-filter="filtering"
                no-data-text="対象データはありません"
                calculate-widths
                fixed-header
                hide-default-footer
                locale="ja-jp"
                dense
              >
                <template v-slot:[`item.actions`]="p">
                  <v-chip
                    small
                    color="primary"
                    @click="onSelectClick(p)"
                  >
                    選択
                  </v-chip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters class="px-1 py-0 mt-3" v-if="filteredRows.length > 0">
          <v-col :cols="3">
            <dd-transparent-button :minWidth="120" @click="onCloseClick">
              <v-icon color="#1F2B38">mdi-close-circle</v-icon>ヘルプを閉じる
            </dd-transparent-button>
          </v-col>
          <v-col :cols="3">
            <dd-custom-button
              v-if="modeKengen === 2"
              :disabled="isHimodukeButtonDisabled"
              @click="onHaishahyoSharyoRelationAddClick">
              チェックした車両を紐付ける
            </dd-custom-button>
          </v-col>
          <v-col :cols="6">
            <v-row no-gutters justify="end">
              <dd-select-items-per-page
                ref="pagination2"
                :itemsPerPage.sync="itemsPerPage"
                :currentPage.sync="page"
                :items="filteredRows"
                @changeItemsPerPage="changeItemsPerPage"
                @changePage="changePage"
              />
            </v-row>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'

import controls from '@/rahmen/controls'
import modals from '@/ddv2.library/modals'

import flowMixin from '@/mixins/flowMixins'
// import filter from '@/rahmen/utils/filters'

import { mapGetters } from 'vuex'

export default {
  name: 'DdSharyoHimodukeDialog',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdNarrowDownTextBox,
    DdSelectItemsPerPage
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * ダイアログタイトル
     */
    titleText: String,
    /**
     * ダイアログタイトル
     */
    haishahyoCdNm: String
  },
  data: () => ({
    rec: [],
    searchText: '',
    recHaishahyoCd: '',
    ctypes: controls,
    modeKengen: 2,
    /**
     * 一覧内容
     */
    loading: false,
    selectedItem: [],
    rows: [],
    // ページネーション用
    itemsPerPage: 0,
    page: 1
    /*
     *
     */
  }),
  created () {
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
    }),
    filteredRows: function (e) {
      return this.rows
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        scrollable: true,
        maxWidth: '85%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isHimodukeButtonDisabled () {
      return this.selectedItem.length === 0
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        searchText: this.searchText
      }
    },
    fetchData: function (haishahyoCd) {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/D2mstd0380/GetUnassignedSharyo?haishahyoCd=${haishahyoCd}`)
          .then((data) => {
            this.rows = data.payload
            this.rows.sort(function (a, b) {
              if (a.sharyoNo > b.sharyoNo) { return 1 }
              if (a.sharyoNo === b.sharyoNo) { return 0 }
              return -1
            }).map((elem) => {
              elem.hacchusakiFlgNm = elem.hacchusakiFlg ? '傭車' : '自社'
              return elem
            })
            this.recHaishahyoCd = haishahyoCd
            resolve()
          })
      })
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: [],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              { text: 'ID', value: 'id', align: ' d-none' },
              { text: '操作', value: 'actions', align: 'center' },
              { text: '車両番号', value: 'sharyoNo' },
              { text: '所有区分', value: 'hacchusakiFlgNm' },
              { text: '営業所', value: 'eigyoshoNm' },
              { text: '発注先', value: 'hacchusakiNm' },
              { text: '自動車表示名', value: 'jidoshaHyojiNm' },
              { text: '自動車登録番号', value: 'torokuNo' },
              { text: '車種種別', value: 'shashuSbtNm' }]
            resolve()
          })
        },
        initializeInputPromise: (c) => {
          return new Promise((resolve) => {
            self.rec = []
            this.rows = []
            this.selectedItem = []
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('savedInputRestorePromise')
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('ThKamotsuHimodukeNippoSearchDialog.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('ThKamotsuHimodukeNippoSearchDialog.researchPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('ThKamotsuHimodukeNippoSearchDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('ThKamotsuHimodukeNippoSearchDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        },
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForViewer(opt)
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      console.log('close clicked', this.showDialog)
      this.$emit('close', undefined)
      console.log('emited', this.showDialog)
      this.searchText = ''
      this.rec = []
      this.rows = []
      this.selectedItem = []
      // this.clear(false)
    },
    onRowDoubleClick: function (e, f) {
      this.selectedItem = [f.item]
      this.onHaishahyoSharyoRelationAddClick()
    },
    onSelectClick: function (f) {
      this.selectedItem = [f.item]
      this.onHaishahyoSharyoRelationAddClick()
    },
    onHaishahyoSharyoRelationAddClick: function () {
      const p = modals.showConfirm
      p('COMQ0001').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.rec = this.selectedItem
        this.rec.map((elem) => {
          elem.haishahyoCd = this.recHaishahyoCd
          return elem
        })

        const self = this
        const opt = {
          registerRequestPromise: self.registerPromise,
          registerResponsePromise: (data) => {
            return new Promise(resolve => {
              console.log(data)
              self.rec = []
              self.selectedItem = []
              self.$emit('saveClose', data.payload)
            })
          },
          getIdMethod: () => {
            return 0
          },
          continuousInputInitializePromise: (id) => {
            return new Promise(resolve => {
              resolve()
            })
          },
          getTransitionBackParams: function () {
            return {
              actionId: 0
            }
          },
          isUpdateModeMethod: function () {
            return true
          },
          isNoRefreshModeMethod: function () {
            return true
          },
          isNoMessageModeMethod: function () {
            return false
          },
          getSavedInputMethod: function () {
            return true
          }
        }
        this.register(opt)
      })
    },
    registerPromise: function () {
      // 登録/更新処理実行
      // 自レコードのみを更新する
      var rtn = this.HttpClient.post('/api/v1/D2mstd0380/CreateHaishahyoSharyoRelation', this.rec)
      return rtn
    },
    // 登録前チェック
    registerValidate: function () {
      return true
    },
    // ページ操作
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    // ダミー
    onDummyFunction: function () {
      this.$emit('dummy')
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 500 !important;
}
</style>
